var _linearGradient, _path, _linearGradient2, _path2, _path3, _linearGradient3, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Mason(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "loQaX2y5VxvlE8PnCq6Sta",
    x1: 14.544,
    x2: 33.04,
    y1: 11.532,
    y2: 28.116,
    gradientTransform: "rotate(45.001 24.5 25.997)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#loQaX2y5VxvlE8PnCq6Sta)",
    d: "M39.991,6.833l-25.672,6.863c-2.232,0.597-2.98,3.386-1.347,5.02l18.81,18.81 c1.634,1.634,4.423,0.885,5.02-1.347l6.863-25.672C44.26,8.277,42.22,6.237,39.991,6.833z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "loQaX2y5VxvlE8PnCq6Stb",
    x1: 22.352,
    x2: 28.696,
    y1: 29.34,
    y2: 33.835,
    gradientTransform: "rotate(45.001 24.5 25.997)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8cdd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#loQaX2y5VxvlE8PnCq6Stb)",
    d: "M25.205,25.292L25.205,25.292c-0.586-0.586-1.536-0.586-2.121,0l-6.718,6.718l2.121,2.121 l6.718-6.718C25.791,26.828,25.791,25.878,25.205,25.292z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad570d",
    d: "M6.113,44.384L6.113,44.384c-1.367-1.367-1.367-3.583,0-4.95l10.253-10.253l4.95,4.95L11.063,44.384 C9.696,45.751,7.48,45.751,6.113,44.384z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "loQaX2y5VxvlE8PnCq6Stc",
    x1: 21,
    x2: 28,
    y1: 35,
    y2: 35,
    gradientTransform: "rotate(45.001 24.5 25.997)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd7d22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d97218"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#loQaX2y5VxvlE8PnCq6Stc)",
    points: "19.902,35.545 14.952,30.595 16.366,29.181 21.316,34.131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Mason);
export default __webpack_public_path__ + "static/media/icons8-mason.5698e5520a13d7eda43007f4462b4f63.svg";
export { ForwardRef as ReactComponent };